import React from 'react';
import * as R from 'ramda';
import { pure, compose, withState, withHandlers } from 'react-recompose';
// components
import { FormGroupTitleMultiple } from '../../components/form-group-title-multiple';
// forms
import { SelectLocation } from './select-location';
import { LocationTemplateSearch } from './template-search/components/location-template-search';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// icons
import * as I from '../../svgs';
// ui
import { Box } from '../../ui';
// components/forms
import BranchLocationForm from './branch-location-form';
import BillToLocationForm, { ContractBillToLocationForm } from './bill-to-location-form';
//////////////////////////////////////////////////

const enhance = compose(
  withState('initialValues', 'setInitialValues', ({ initialValues }) => initialValues),
  withHandlers({
    handleSearchLocation: (props) => () => {
      const { isBillTo, formType, openModal, closeModal, setInitialValues } = props;

      const searchTemplateRequest = (location) => {
        let mappedLocation = G.mapSearchedLocation2(location, { useMultiEmails: true });

        if (R.equals(formType, GC.LOCATION_FORM_TYPE_BRANCH_LOCATION)) {
          mappedLocation = G.mapSearchedLocationWithContactsArr(location);
        }

        setInitialValues((prev) => R.mergeRight(prev, mappedLocation));
        closeModal();
      };

      const modalContent = (
        <LocationTemplateSearch
          {...G.getLocationTemplateSearchRequestProps(props)}
          billTo={isBillTo}
          closeModal={closeModal}
          searchTemplateRequest={searchTemplateRequest}
        />
      );

      const modal = G.createCommonModalOptions(modalContent);

      openModal(modal);
    },
    handleSelectLocation: (props) => () => {
      const { openModal, closeModal, initialValues, setInitialValues } = props;

      const searchTemplateRequest = (location) => {
        const needValues = R.pick(GC.GROUPED_FIELDS.EVENT_LOCATION_ARR, location);

        setInitialValues((prev) => R.mergeRight(G.mapObjectNullFieldsToEmptyStrings(prev), needValues));
        closeModal();
      };

      const modalContent = (
        <SelectLocation
          closeModal={closeModal}
          initialValues={initialValues}
          searchTemplateRequest={searchTemplateRequest}
        />
      );

      const modal = G.createCommonModalOptions(modalContent);

      openModal(modal);
    },
  }),
  pure,
);

const FormComponent = (props) => {
  if (R.propEq(GC.LOCATION_FORM_TYPE_BILL_TO, 'formType', props)) {
    return <BillToLocationForm {...props} />;
  }

  if (R.propEq(GC.LOCATION_FORM_TYPE_BRANCH_LOCATION, 'formType', props)) {
    return <BranchLocationForm {...props} />;
  }

  if (R.propEq(GC.LOCATION_FORM_TYPE_CONTRACT_BILL_TO_LOCATION, 'formType', props)) {
    return <ContractBillToLocationForm {...props} />;
  }
};

export const LocationFormWithSearch = enhance((props) => (
  <Box width={655}>
    <FormGroupTitleMultiple
      mb='0'
      title={props.title}
      showArrowToggle={false}
    >
      <Box ml={10} pt='4px' cursor='pointer' onClick={props.handleSearchLocation}>
        {I.search(G.getTheme('icons.iconColorGrey'))}
      </Box>
      <Box ml={10} pt='4px' cursor='pointer' onClick={props.handleSelectLocation}>
        {I.location(G.getTheme('icons.iconColorGrey'))}
      </Box>
    </FormGroupTitleMultiple>
    <FormComponent
      formType={props.formType}
      loadType={props.loadType}
      loadGuid={props.loadGuid}
      eventGuid={props.eventGuid}
      eventType={props.eventType}
      branchGuid={props.branchGuid}
      closeModal={props.closeModal}
      fieldOptions={props.fieldOptions}
      submitBtnText={props.submitBtnText}
      submitHandler={props.submitHandler}
      initialValues={props.initialValues}
      searchedValues={props.searchedValues}
      optionsForSelect={props.optionsForSelect}
      setInitialValues={props.setInitialValues}
      submitAndSaveLocation={props.submitAndSaveLocation}
    />
  </Box>
));
